module.exports = __webpack_public_path__ + "img/network-wired.5b72d04e.svg";